// Trait metadata for in-game base corgis (#1–500), keyed by tokenId.

import traitsList from "../data/corgiTraits.json";
import { normalizeCardId } from "./cardCatalog";

const TRAITS_BY_ID = traitsList.reduce((map, row) => {
    const id = normalizeCardId(row?.tokenId);
    if (Number.isFinite(id)) {
        map[id] = row;
        map[String(id)] = row;
    }
    return map;
}, {});

export function getCorgiTraits(cardId) {
    const id = normalizeCardId(cardId);
    if (!Number.isFinite(id)) {
        return null;
    }
    return TRAITS_BY_ID[id] || null;
}

export function getCorgiBaseModel(cardId) {
    return String(getCorgiTraits(cardId)?.["Base Models"] || "").trim();
}

export function isOriginalBaseCorgiModel(cardId) {
    return getCorgiBaseModel(cardId) === "OriginalBaseCorgi";
}

export function listInGameCorgiTraits() {
    return traitsList.slice();
}
